module.exports = __webpack_public_path__ + "media/club_product_v2/7-7e6a9a6f.webp";